// import React, { Suspense } from "react";
import loadable from "@loadable/component";

// const ScrollToTop = lazy(() => import("./ScrollToTop"), { ssr: false });
const ScrollToTop = loadable(() => import("./ScrollToTop"), {
	ssr: false,
});

export default ScrollToTop;
